var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHuddledeckSquares(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15.507,
    viewBox: "0 0 15 15.507",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "squares",
    transform: "translate(-8.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3747",
    "data-name": "Path 3747",
    d: "M188.537,1.729h-4.617V.312A.313.313,0,0,0,183.608,0h-3.865a.313.313,0,0,0-.313.312V4.177a.313.313,0,0,0,.313.312h3.865a.313.313,0,0,0,.313-.312V2.76h4.1v4.5h-.63l.268-.653a.063.063,0,0,0-.086-.081l-2.4,1.186a.07.07,0,0,0,0,.126l2.4,1.186a.063.063,0,0,0,.071-.011.063.063,0,0,0,.015-.07l-.268-.653h1.145a.516.516,0,0,0,.516-.516V2.245A.516.516,0,0,0,188.537,1.729Z",
    transform: "translate(-165.969)",
    fill: "#283e76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3748",
    "data-name": "Path 3748",
    d: "M17.639,175.518H13.775a.313.313,0,0,0-.313.312v1.438H8.6a.515.515,0,0,0-.516.516v5.53a.515.515,0,0,0,.516.516H9.745l-.268.653a.063.063,0,0,0,.086.081l2.4-1.186a.071.071,0,0,0,0-.126l-2.4-1.186a.063.063,0,0,0-.086.081l.268.653h-.63v-4.5h4.347v1.4a.313.313,0,0,0,.313.312h3.864a.313.313,0,0,0,.313-.312V175.83A.313.313,0,0,0,17.639,175.518Z",
    transform: "translate(0 -170.009)",
    fill: "#283e76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3749",
    "data-name": "Path 3749",
    d: "M183.608,351.036h-3.865a.313.313,0,0,0-.313.312v3.865a.313.313,0,0,0,.313.312h3.865a.313.313,0,0,0,.313-.312v-3.865A.313.313,0,0,0,183.608,351.036Z",
    transform: "translate(-165.969 -340.018)",
    fill: "#283e76"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuddledeckSquares);
export default __webpack_public_path__ + "static/media/huddledeck-squares.696a55114ae09084dd0cc10ff72f7620.svg";
export { ForwardRef as ReactComponent };